<template>
  <div class="spinner-wrapper spinner-block" :class="{ show: isReady }">
    <div class="spinner" />
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';

const running = ref(false);

const isReady = computed(() => running.value);

const run = () => {
  running.value = true;
};

const stop = () => {
  running.value = false;
};

onMounted(() => {
  window.$bus.on('spinner-run', () => {
    run();
  });

  window.$bus.on('spinner-stop', () => {
    stop();
  });
});
</script>
